export enum customHeaders {
  x_app_version = 'x-app-version',
  x_tenant_package = 'x-tenant-package',
}
